export var version = "3.12.3";
//# sourceMappingURL=version.js.map